import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/contextParameters'

const initialState = null

export default (prevState, action) => {
  if (typeof prevState === 'undefined') return initialState

  const mergeState = R.mergeRight(prevState)

  switch (action.type) {
    case actionTypes.SET_CONTEXT_PARAMETERS:
      return mergeState(action.contextParameters)
    case actionTypes.CLEAR_CONTEXT_PARAMETERS:
      return initialState
    default:
      return prevState
  }
}
